import React from 'react';
import PropTypes from 'prop-types';
import { IconText } from 'web-ui-components/lib/molecules/icon-text';
import { ActionButton } from 'web-ui-components/lib/actions/buttons';
import { BrandedPanel } from 'web-ui-components/lib/layout/content';
import { CompactDescriptionList } from 'web-ui-components/lib/data/lists';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody, SubBody, SignificantBody } from 'web-ui-components/lib/typography/body';
import { compose } from 'redux';
import withContent from '../../containers/withContent';
import liveRateContent, { contentPropTypes } from './LiveRateBox.content';
import { formatIFTAmount } from '../../utils/numberUtils';

export const LiveRateBox = ({
	content: { heading, description, title, rateCounterText = '', expiredRateText, buttonText } = {},
	counter,
	showInitialGetRate,
	showRefresh,
	exchangeRate,
	showExchangeRate,
	onRefresh,
}) => {
	const rateCounter = rateCounterText.replace(':counter', counter);

	const getRate = () =>
		showExchangeRate ? <strong>{formatIFTAmount(exchangeRate, '')}</strong> : <strong> - </strong>;

	return (
		<BrandedPanel>
			<SectionHeading>{heading}</SectionHeading>
			<StandardBody>
				<p>{description}</p>
			</StandardBody>

			<CompactDescriptionList
				data-test-id="display-exchange-rate"
				breakpointSnap="1280"
				items={[
					{
						key: title,
						value: getRate(),
					},
				]}
			/>

			{showInitialGetRate && (
				<ActionButton.Primary
					onClick={onRefresh}
					labelText={buttonText}
					data-test-id="action-button-initial-get-rate"
				/>
			)}

			{!showInitialGetRate && !showRefresh && (
				<SignificantBody>
					<IconText iconType="ClockOutlineLarge">{rateCounter}</IconText>
				</SignificantBody>
			)}
			{!showInitialGetRate && showRefresh && (
				<div>
					<ActionButton.Primary onClick={onRefresh} labelText="Refresh" data-test-id="action-button-get-rate-refresh" />
					<SubBody>{expiredRateText}</SubBody>
				</div>
			)}
		</BrandedPanel>
	);
};

LiveRateBox.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	counter: PropTypes.number.isRequired,
	onRefresh: PropTypes.func.isRequired,
	showRefresh: PropTypes.bool.isRequired,
	showExchangeRate: PropTypes.bool.isRequired,
	exchangeRate: PropTypes.string.isRequired,
};

const connectors = compose(withContent({ content: liveRateContent }));

export default connectors(LiveRateBox);
